import { render, staticRenderFns } from "./cuccOpen1.vue?vue&type=template&id=93f2f804&scoped=true&"
var script = {}
import style0 from "./cuccOpen1.vue?vue&type=style&index=0&id=93f2f804&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f2f804",
  null
  
)

export default component.exports